import React from "react";
import { Row, Col } from "reactstrap";

const NumberInput = ({
  label,
  value,
  onIncrement,
  onDecrement,
  onChange,
  min = 1,
  containerClassName = "",
  imgSrc = "",
}) => {
    const handleChange = (e) => {
        const inputVal = Number(e.target.value);
        const newVal = inputVal < min ? min : inputVal;
        onChange({ ...e, target: { ...e.target, value: newVal } });
      };

  return (
    <div className={`no-spinner number-input-container ${containerClassName}`}>
      <Row className="align-items-center">
        <Col xs={6}>
            {imgSrc && (<img className="checkout-icon" src={imgSrc} alt="icon" />)}
          <label className="ad_120_bold pl-2 number-input-text">{label}</label>
        </Col>
        <Col xs={6} className="text-right">
          <div className="input-group number-input-group">
            <div className="input-group-prepend">
              <button
                className="btn"
                type="button"
                onClick={onDecrement}
              >
                –
              </button>
            </div>
            <input
              type="number"
              className="form-control text-center number-input-field"
              value={value}
              onChange={handleChange}
              min={min}
            />
            <div className="input-group-append">
              <button
                className="btn"
                type="button"
                onClick={onIncrement}
              >
                +
              </button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default NumberInput;



// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Order/NumberInput.js